import { type UserAction, userActions, type UserState } from '../context';

export const userReducer = (state: UserState, action: UserAction) => {
  let updatedState = state;
  switch (action.type) {
    case userActions.SET_IS_AUTHENTICATED:
      updatedState = {
        ...state,
        user: { ...state.user, isAuthenticated: action.payload }
      };
      break;
    case userActions.SET_USER:
      updatedState = {
        ...state,
        user: {
          ...state.user,
          id: action.payload.id,
          name: action.payload.name,
          username: action.payload.username,
          isPrivate: action.payload.isPrivate,
          email: action.payload.email,
          emailVerificationStatus: action.payload.emailVerificationStatus,
          bio: action.payload.bio,
          avatarKey: action.payload.avatarKey,
          robohash: action.payload.robohash,
          bannerKey: action.payload.bannerKey,
          twoFaEnabled: action.payload.twoFaEnabled,
          tronsBalance: action.payload.tronsBalance,
          onboardingPath: action.payload.onboardingPath,
          oauthProviders: action.payload.oauthProviders,
          oauthProvider: action.payload.oauthProvider,
          hasPassword: action.payload.hasPassword,
          hasPasskey: action.payload.hasPasskey,
          tag: action.payload.tag,
          verificationRequestedAt: action.payload.verificationRequestedAt,
          isIncognito: action.payload.isIncognito
        }
      };
      break;
    case userActions.ADD_TRONS:
      updatedState = {
        ...state,
        user: {
          ...state.user,
          tronsBalance: state.user.tronsBalance + action.payload
        }
      };
      break;
    default:
      return state;
  }
  return updatedState;
};
